import { render } from "./OtherRevenues.vue?vue&type=template&id=fc915412&scoped=true"
import script from "./OtherRevenues.vue?vue&type=script&lang=js"
export * from "./OtherRevenues.vue?vue&type=script&lang=js"

import "./OtherRevenues.vue?vue&type=style&index=0&id=fc915412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc915412"]])

export default __exports__